import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/Builder/BuilderContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/Builder/GenerateDraftContent.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/HealthcareEntries/Breadcrumbs/breadcrumbs.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/HealthcareEntries/Content/content.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/HealthcareEntries/Header/header.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/HealthcareEntries/entry.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/HealthcareEntries/LearningCenterGate/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/HealthcareEntries/LearningCenterIndicator/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/molecules/Main/main.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/HealthcareEntries/Disclaimer/disclaimer.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/HealthcareEntries/RelatedContent/related-content.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/molecules/Socials/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/utils/hooks/sendGtmEvent.tsx");
